import axios from 'axios';

const get = (cep) => axios.get(`/open/cep/${cep}`);

export default {
  get,
};
